var _react_refresh_temp_1;
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
const InitialComponent = ({ children }) => _jsx(_Fragment, { children: children });
_react_refresh_temp_1 = InitialComponent;
$RefreshReg$(_react_refresh_temp_1, "InitialComponent");
export const buildComponentsTree = (componentsWithProps) => {
    return componentsWithProps.reduce(
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Must start with capital letter in this case
    (AccumulatedComponents, [Component, props]) => ({ children }) => (_jsx(AccumulatedComponents, { children: _jsx(Component, { ...props, children: children }) })), InitialComponent);
};
